import { AslDTO, CooperativaDTO, PuntoServizioDTO, UserRole } from '../common/Dtos';
import React, { useContext, useEffect, useState } from 'react';
import { createStyles, makeStyles, Theme } from '@material-ui/core/styles';
import { Dialog, DialogActions, DialogContent, FormControl, Grid, MenuItem, Select, TextField } from '@material-ui/core';
import { SDialogButton, SDialogTitle, SInputLabel } from '../common/BCommonComponents';
import AuthContext from '../auth/AuthContext';

interface AggiungiPuntoServizioDialogProps {
	open: boolean;
	onClose: (puntoServizio?: PuntoServizioDTO) => void;
	aslList: AslDTO[];
	cooperativeList: CooperativaDTO[];
}

function AggiungiPuntoServizioDialog(props: AggiungiPuntoServizioDialogProps) {
	const auth = useContext(AuthContext);
	const {onClose, open, aslList, cooperativeList} = props;
	const [puntoServizio, setPuntoServizio] = useState<PuntoServizioDTO>({
		cooperativa: '',
		createdBy: '',
		createdDate: '',
		id: '',
		puntoServizioConfig:false,
		indirizzo: '',
		lastModifiedBy: '',
		lastModifiedDate: '',
		name: '',
		operatori: [],
		asl: '',
		telefono: '',
		email: '',
		codiceDefinitivo: '',
		codiceTemporaneo: '',
		action: '',
		cooperativaName: ''
	})
	const [errorNome, setErrorNome] = useState<boolean>(false);
	const [errorAsl, setErrorAsl] = useState<boolean>(false);
	const [errorCooperativa, setErrorCooperativa] = useState<boolean>(false);
	const [errorValidEmail, setErrorValidEmail] = useState<boolean>(false);

	useEffect(() => {
	}, [puntoServizio]);

	useEffect(() => {
		setPuntoServizio({
			cooperativa: '',
			createdBy: '',
			createdDate: '',
			id: '',
			puntoServizioConfig:false,
			indirizzo: '',
			lastModifiedBy: '',
			lastModifiedDate: '',
			name: '',
			operatori: [],
			asl: '',
			telefono: '',
			email: '',
			action: '',
			codiceDefinitivo: '',
			codiceTemporaneo: '',
			cooperativaName: ''
		});
	}, [open]);

	const handleConferma = () => {
		if (puntoServizio.name === ''
			|| puntoServizio.asl === ''
			|| (puntoServizio.email && puntoServizio.email !== '' && !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(puntoServizio.email))
		|| (auth.state.roles && auth.state.roles.indexOf(UserRole.ADMIN) >= 0 && puntoServizio.cooperativa === '')) {
			setErrorNome(puntoServizio.name === '');
			setErrorAsl(puntoServizio.asl === '');
			setErrorValidEmail(puntoServizio.email !== null && puntoServizio.email !== '' && !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(puntoServizio.email));
			setErrorCooperativa(puntoServizio.cooperativa === '');
		} else {
			setErrorNome(false);
			setErrorAsl(false);
			setErrorValidEmail(false);
			setErrorCooperativa(false);
			onClose(puntoServizio);
		}
	};

	const handleClose = () => {
		onClose();
	}

	const handleNomeChange = (event: React.ChangeEvent<HTMLInputElement>) => {
		const newPunto = {
			cooperativa: puntoServizio.cooperativa,
			createdBy: '',
			createdDate: '',
			id: '',
			indirizzo: puntoServizio.indirizzo,
			lastModifiedBy: '',
			lastModifiedDate: '',
			name: event.target.value,
			operatori: [],
			puntoServizioConfig:false,
			asl: puntoServizio.asl,
			telefono: puntoServizio.telefono,
			email: puntoServizio.email,
			codiceDefinitivo: '',
			codiceTemporaneo: '',
			action: '',
			cooperativaName: ''
		}
		setPuntoServizio(newPunto);
	};

	const handleIndirizzoChange = (event: React.ChangeEvent<HTMLInputElement>) => {
		const newPunto = {
			cooperativa: puntoServizio.cooperativa,
			createdBy: '',
			createdDate: '',
			id: '',
			indirizzo: event.target.value,
			lastModifiedBy: '',
			lastModifiedDate: '',
			name: puntoServizio.name,
			operatori: [],
			puntoServizioConfig:false,
			asl: puntoServizio.asl,
			telefono: puntoServizio.telefono,
			email: puntoServizio.email,
			codiceDefinitivo: '',
			codiceTemporaneo: '',
			action: '',
			cooperativaName: ''
		}
		setPuntoServizio(newPunto);
	};

	const handleEmailChange = (event: React.ChangeEvent<HTMLInputElement>) => {
		const newPunto = {
			cooperativa: puntoServizio.cooperativa,
			createdBy: '',
			createdDate: '',
			id: '',
			indirizzo: puntoServizio.indirizzo,
			lastModifiedBy: '',
			lastModifiedDate: '',
			name: puntoServizio.name,
			operatori: [],
			puntoServizioConfig:false,
			asl: puntoServizio.asl,
			telefono: puntoServizio.telefono,
			email: event.target.value,
			codiceDefinitivo: '',
			codiceTemporaneo: '',
			action: '',
			cooperativaName: ''
		}
		setPuntoServizio(newPunto);
	};

	const handleTelefonoChange = (event: React.ChangeEvent<HTMLInputElement>) => {
		const newPunto = {
			cooperativa: puntoServizio.cooperativa,
			createdBy: '',
			createdDate: '',
			id: '',
			indirizzo: puntoServizio.indirizzo,
			lastModifiedBy: '',
			lastModifiedDate: '',
			name: puntoServizio.name,
			operatori: [],
			puntoServizioConfig:false,
			asl: puntoServizio.asl,
			telefono: event.target.value,
			email: puntoServizio.email,
			codiceDefinitivo: '',
			codiceTemporaneo: '',
			action: '',
			cooperativaName: ''
		}
		setPuntoServizio(newPunto);
	};

	const handleCooperativaChange = (event: React.ChangeEvent<{ value: unknown }>) => {
		const newPunto = {
			...puntoServizio,
			cooperativa: event.target.value as string
		}
		setPuntoServizio(newPunto);
	};

	const handleAslChange = (event: React.ChangeEvent<{ value: unknown }>) => {
		const newPunto = {
			cooperativa: puntoServizio.cooperativa,
			createdBy: '',
			createdDate: '',
			id: '',
			indirizzo: puntoServizio.indirizzo,
			lastModifiedBy: '',
			lastModifiedDate: '',
			name: puntoServizio.name,
			operatori: [],
			puntoServizioConfig:false,
			asl: event.target.value as string,
			telefono: puntoServizio.telefono,
			email: puntoServizio.email,
			codiceDefinitivo: '',
			codiceTemporaneo: '',
			action: '',
			cooperativaName: ''
		}
		setPuntoServizio(newPunto);
	};

	const useStyles = makeStyles((theme: Theme) =>
		createStyles({
			formControl: {
				width: '100%',
			},
			selectEmpty: {
				width: '100%',
				margin: '0',
			},
		}),
	);

	const classes = useStyles();

	return (
		<Dialog
			disableBackdropClick
			open={open}>
			<SDialogTitle className="pb-0" id="simple-dialog-title">NUOVO PUNTO SERVIZIO</SDialogTitle>
			<DialogContent>
				<Grid container spacing={0} className="w-100">
					<Grid item xs={12} className="px-2">
						<TextField
							className="w-100"
							id="nomePuntoServizio"
							label="Nome"
							variant="outlined"
							value={puntoServizio.name}
							onChange={handleNomeChange}
							error={errorNome}
							InputLabelProps={{shrink: true}}
							required={true}
						/>
					</Grid>
				</Grid>
				<Grid container spacing={0} className="w-100 mt-3">
					{auth.state.roles && auth.state.roles.indexOf(UserRole.ADMIN) >= 0 &&
					<Grid item xs={6} className="px-2">
						<FormControl variant="outlined" className={classes.formControl} error={errorCooperativa} required={true}>
							<SInputLabel id="cooperativa">Cooperativa</SInputLabel>
							<Select
								required
								labelId="cooperativa"
								id="cooperativaSelect"
								className={classes.selectEmpty}
								label="Cooperativa"
								value={puntoServizio.cooperativa}
								onChange={handleCooperativaChange}
								MenuProps={{
									anchorOrigin: {
										vertical: "bottom",
										horizontal: "left"
									},
									transformOrigin: {
										vertical: "top",
										horizontal: "left"
									},
									getContentAnchorEl: null
								}}
							>
								{cooperativeList && cooperativeList.map(op => {
									return (
										<MenuItem value={op.id} key={op.id}>{op.name}</MenuItem>
									)
								})}
							</Select>
						</FormControl>
					</Grid>
					}
					<Grid item xs={auth.state.roles && auth.state.roles.indexOf(UserRole.ADMIN) >= 0 ? 6 : 12} className={auth.state.roles && auth.state.roles.indexOf(UserRole.ADMIN) >= 0 ? "pr-2" : "px-2"}>
						<FormControl variant="outlined" className={classes.formControl} error={errorAsl} required={true}>
							<SInputLabel id="asl">ASL</SInputLabel>
							<Select
								required
								labelId="Selezione ASL"
								id="asl"
								className={classes.selectEmpty}
								label="Selezione ASL"
								value={puntoServizio.asl}
								onChange={handleAslChange}
								MenuProps={{
									anchorOrigin: {
										vertical: "bottom",
										horizontal: "left"
									},
									transformOrigin: {
										vertical: "top",
										horizontal: "left"
									},
									getContentAnchorEl: null
								}}
							>
								{aslList.map((item) => {
									return (
										<MenuItem value={item.id} key={item.id}>{item.name}</MenuItem>
									);
								})
								}
							</Select>
						</FormControl>
					</Grid>
					<Grid container spacing={0} className="w-100 mt-3">
						<Grid item xs={12} className="px-2">
							<TextField
								className="w-100"
								id="indirizzoPuntoServizio"
								label="Indirizzo"
								variant="outlined"
								value={puntoServizio.indirizzo}
								onChange={handleIndirizzoChange}
								InputLabelProps={{shrink: true}}
							/>
						</Grid>
					</Grid>
					<Grid container spacing={0} className="w-100 mt-3">
						<Grid item xs={6} className="px-2">
							<TextField
								className="w-100"
								id="emailPuntoServizio"
								label="Email"
								type="email"
								helperText={errorValidEmail && "Formato email non corretto"}
								variant="outlined"
								value={puntoServizio.email}
								onChange={handleEmailChange}
								error={errorValidEmail}
								InputLabelProps={{shrink: true}}
							/>
						</Grid>
						<Grid item xs={6} className="px-2">
							<TextField
								className="w-100"
								id="telefonoPuntoServizio"
								label="Telefono"
								type="phone"
								variant="outlined"
								value={puntoServizio.telefono}
								onChange={handleTelefonoChange}
								InputLabelProps={{shrink: true}}
							/>
						</Grid>
					</Grid>
				</Grid>
			</DialogContent>
			<DialogActions className="p-4">
				<SDialogButton className="float-right" onClick={handleConferma}>CONFERMA</SDialogButton>
				<SDialogButton className="float-right" variantcolor="secondary" onClick={handleClose}>ANNULLA</SDialogButton>
			</DialogActions>
		</Dialog>
	);
}

export default AggiungiPuntoServizioDialog;
